import { forwardRef, useRef, useMemo, useState, useEffect } from "react";
import context from "lib/stores/context";
import { useSnapshot } from "valtio";
import classNames from "classnames";
import styles from "./index.module.scss";
import { Tab } from "@headlessui/react";
import CountriesPanel from "components/DataPanels/DataPanelCountries";
import ExploreTheDataPanel from "components/DataPanels/DataPanelExplore";
import InFocusPanel from "components/DataPanels/DataPanelInFocus";
import RegionsPanel from "components/DataPanels/DataPanelRegions";
import RecommendationsPanel from "components/DataPanels/DataPanelRecommendations";
import { abort } from "process";

const SidebarPanels = forwardRef(({ offset }, ref) => {
  const { activeView } = useSnapshot(context);

  const renderPanelsForActiveView = () => {
    switch (activeView) {
      case "worldwide":
        return (
          <>
            <CountriesPanel />
            <RegionsPanel />
            <InFocusPanel />
          </>
        );
      case "region":
        return (
          <>
            <CountriesPanel />
            <InFocusPanel />
            <ExploreTheDataPanel />
          </>
        );
      case "country":
        return (
          <>
            <RecommendationsPanel />
            <InFocusPanel />
            <ExploreTheDataPanel />
          </>
        );
      default:
        return (
          <>
            <CountriesPanel />
            <RegionsPanel />
            <InFocusPanel />
          </>
        );
    }
  };

  return (
    <div id="sidebar-panels-wrapper" className={styles["sidebar-panels-wrapper"]}>
      <Tab.Panels>{renderPanelsForActiveView()}</Tab.Panels>
    </div>
  );
});

export default SidebarPanels;
